const scene360 = {}

export default scene360